import { stageGet } from "@/shared/api";

/** Вариант ответа на вопрос о состоянии: "Как новое", "Хорошее", "С дефектами" */
export interface StatusOption {
    cid: string;
    cname: string;
    description: string;
    /** Идентификатор картинки варианта */
    imgCid: string;
    code: string;
}

/** Вопрос о состоянии сдаваемого устройства */
export interface StatusQuestion {
    questionId: string;
    question: string;
    description: string;
    options: StatusOption[];
    answerType: string;
    horizontalOrientation: boolean;
    imgCid: string;
    canComment: boolean;
    last: boolean;
    terminate: boolean;
}

/**
 * Получить вопрос о состоянии устройства
 * 6.1 документация ru 1.0.5
 */
export function apiGetStatusQuestion(payload: {
    deviceId: string;
    token: string;
    lang: string;
}): Promise<StatusQuestion> {
    return stageGet<StatusQuestion>("/api/tin/v1/site/quest/question", payload);
}
